import { render, staticRenderFns } from "./IP_ChecklistSummary.vue?vue&type=template&id=02270ea5&scoped=true&"
import script from "./IP_ChecklistSummary.vue?vue&type=script&lang=js&"
export * from "./IP_ChecklistSummary.vue?vue&type=script&lang=js&"
import style0 from "./IP_ChecklistSummary.vue?vue&type=style&index=0&id=02270ea5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02270ea5",
  null
  
)

export default component.exports